<template>
    <div>
        <div class="form-group col-12 mt-3">
            <b-form-checkbox v-model="linkOnly" switch>
                Link Only
            </b-form-checkbox>
        </div>
        <div v-if="linkOnly" class="form-group col-12">
            <label :id="id">Video Link</label>
            <input
                :id="id"
                v-model="video.link"
                type="text"
                class="form-control"
                placeholder="Link"
                @input="$emit('input', video)"
            />
        </div>
        <div v-else class="form-group col-12">
            <label>Video</label>
            <media-chooser
                :value="video.videoData"
                type="video"
                @input="onVideoChange"
            />
        </div>
        <div class="form-group col-12">
            <label>Thumbnail</label>
            <media-chooser
                :value="video.image"
                type="image"
                @input="onImageChange"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            video: {},
            linkOnly: true,
            id: Math.random()
                .toString(36)
                .substring(2, 15)
                .match(/[a-zA-Z]+/g)
                .join('')
        };
    },

    watch: {
        linkOnly() {
            this.video.linkOnly = this.linkOnly;

            this.$emit('input', this.video);
        }
    },

    mounted() {
        this.video = { ...this.value };

        this.linkOnly = this.video.linkOnly;
    },

    methods: {
        onImageChange(image) {
            this.video = { ...this.video, image };

            this.$emit('input', this.video);
        },

        onVideoChange(videoData) {
            this.video = { ...this.video, videoData };

            this.$emit('input', this.video);
        }
    }
};
</script>
